// import React from 'react'
import React, { useState, useEffect, useContext } from 'react'

import { InsightText, TreeTable, Switch, Button } from "freespace-react-components";
import LiveTree from '../../assets/images/SVGComponents/LiveTree';
import HealthOverviewContext from '../../context/HealthOverviewContext';

import Info from '../../assets/images/SVGComponents/Info';
import BackArrow from '../../assets/images/SVGComponents/BackArrow';





const AccountWiseHealth = () => {
    const { quickInfoData } = useContext<any>(HealthOverviewContext)
    const { overallInfo } = useContext<any>(HealthOverviewContext)
    const { liveTreeAPIData } = useContext<any>(HealthOverviewContext)

    const [showQuickInfo, setShowQuickInfo] = useState(false);


    return (
        <div className="flex w-full h-[100vh]">
            <div className="flex flex-col w-full">
                <div className=" flex w-full h-full divide-x divide-dividerLines bg-backgroundColor">
                    <div className="w-full md:w-4/5 flex flex-col justify-between ">
                        <div>
                            <div className={`flex bg-green-50 h-16 drop-shadow-md overflow-x-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style]:none [scrollbar-width]:none`}>
                                <InsightText
                                    primaryText={"91 King William Street-7th Floor"}
                                    secondaryText={
                                        <div className='flex flex-col text-xs'>
                                            <p>Australia-Adelaide</p>
                                        </div>
                                    }
                                    contentInput={
                                        <p className=" text-xs">25%</p>
                                    }
                                />
                                <InsightText
                                    primaryText={"91 King William Street-7th Floor"}
                                    secondaryText={
                                        <div className='flex flex-col text-xs'>
                                            <p>Australia-Adelaide</p>
                                        </div>
                                    }
                                    contentInput={
                                        <p className="text-xs">25%</p>
                                    }
                                />
                                <InsightText
                                    primaryText={"91 King William Street-7th Floor"}
                                    secondaryText={
                                        <div className='flex flex-col text-xs'>
                                            <p>Australia-Adelaide</p>
                                        </div>
                                    }
                                    contentInput={
                                        <p className=" text-xs">25%</p>
                                    }
                                />
                                <InsightText
                                    primaryText={"91 King William Street-7th Floor"}
                                    secondaryText={
                                        <div className='flex flex-col text-xs'>
                                            <p>Australia-Adelaide</p>
                                        </div>
                                    }
                                    contentInput={
                                        <p className=" text-xs">25%</p>
                                    }
                                />
                            </div>
                            <TreeTable
                                data={liveTreeAPIData}
                                commonColumsName={['Name', 'Type', 'Id', 'Overall']}
                                columnsName={['ONE', 'FLO', 'BAT-FLO', 'TIM', 'BAT-TIM', 'TIM+', 'BAT-TIM+', 'PAM','MS']}
                                extraTableHeaderElement={[
                                    // <div key="in-risk-view" className='flex justify-center items-center gap-2'>
                                    //     <p className='text-xs lg:text-sm font-normal'>In-Risk View</p>
                                    //     <Switch
                                    //         onChange={(isChecked) => {
                                    //             // console.log(isChecked);
                                    //         }}
                                    //     />
                                    // </div>,
                                    <div key="clear-filter" className='flex justify-center items-center gap-2'>
                                        <Button
                                            // className='py-1.5 px-2 text-xs lg:text-sm h-6 font-sans'
                                            // type="button"
                                            severity='success'
                                            size="small"
                                            icon='pi pi-sparkles'
                                            outlined={true}
                                            onClick={() => {
                                                // console.log('sparkles clciked ');
                                                setShowQuickInfo(!showQuickInfo);
                                            }}
                                        />
                                    </div>]
                                }
                            />
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )

}

export default AccountWiseHealth;